import { staticColors } from '../../../../../const/colors/staticColors';
import { getDisabledColorOpacity } from '../../../../../helpers/getColorOpacity';
const DARK_TEXT_COLOR = staticColors.textDark;
const GREY_TEXT_COLOR = staticColors.textGrey;
const WHITE_TEXT_COLOR = staticColors.textWhite;
export const getDayTextColor = ({ isOutOfCurrentMonth, isSelectedDay, isBlockedDay, }) => {
    if (isSelectedDay) {
        return WHITE_TEXT_COLOR;
    }
    if (isBlockedDay) {
        const textColor = getDisabledColorOpacity(DARK_TEXT_COLOR);
        return textColor;
    }
    if (isOutOfCurrentMonth) {
        return GREY_TEXT_COLOR;
    }
    return DARK_TEXT_COLOR;
};
